import {
  FocusContext,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import React, { useEffect } from 'react'

import {
  TEMPORAL_SETTINGS_AVAILABLE,
  activateTemporarySetting,
} from '../../lib/utils.js'
import Platform from '../../platforms/index.js'

import { useNavigate, useParams } from 'react-router'
import { VideoPlayerProvider } from '../../components/VideoPlayer/VideoPlayerContext'
import { useAppSelector } from '../../hooks/useStore'
import { useVideoDetails } from '../../hooks/useVideoDetails'
import { useVppaModalProvider } from './context/VPPAModalProvider'
import VideoPlayerContainer from './VideoPlayerContainer'

function VideoPlaybackScreen() {
  const navigate = useNavigate()
  const routerParams = useParams()
  const { validPassport, vppa_status: vppaStatus } = useAppSelector(
    (state) => state.user
  )
  const callSign = useAppSelector((state) => state.station.call_sign)
  const { videoDetails, error: errorGettingVideoDetails } = useVideoDetails(
    routerParams.url || ''
  )
  const {
    openVppaModal,
    isVppaModalOpen,
    setIsVppaModalChecked,
    isVppaModalChecked,
  } = useVppaModalProvider()

  //TODO: Remove this when whole app is migrated to spatial navigation
  useEffect(() => {
    window.focusedComponent = {}
    window.focusedComponent.handleBySpatialNavigation = true
    return () => {
      window.focusedComponent.handleBySpatialNavigation = false
    }
  }, [])

  useEffect(() => {
    if (errorGettingVideoDetails) {
      navigate('/error', { replace: true })
    }
  }, [errorGettingVideoDetails, navigate])

  useEffect(() => {
    if (videoDetails?.url && !validPassport && !videoDetails?.isPlayable) {
      const windowUrl = window.location.href.split('/')[4]
      navigate(`/passport-upsell/${callSign}?video=${routerParams.url}`, {
        state: { goBackParameterUrl: windowUrl },
      })
    }
  }, [videoDetails, validPassport, callSign, routerParams.url, navigate])

  useEffect(() => {
    Platform.reportAppReady()
    checkVppaAgreement()
  }, [])

  const { focusKey, ref } = useFocusable({
    isFocusBoundary: true,
    forceFocus: true,
  })

  const checkVppaAgreement = () => {
    const handleCloseVppaModal = ({ accepted }: { accepted: boolean }) => {
      if (accepted) {
        activateTemporarySetting(TEMPORAL_SETTINGS_AVAILABLE.VPPA)
      } else {
        const windowUrl = location.pathname.split('/')[2]
        navigate(`/video-details/${windowUrl}`, {
          state: { fromVPPA: true },
        })
      }
    }

    const userNeedsVppaConsent =
      vppaStatus === 'never_accepted' ||
      vppaStatus === 'expired' ||
      vppaStatus === 'rejected'
    const showVPPAModal =
      !videoDetails?.isPlayable &&
      userNeedsVppaConsent &&
      videoDetails?.is_mvod &&
      validPassport
    if (showVPPAModal) {
      openVppaModal(handleCloseVppaModal)
    }
    setTimeout(() => setIsVppaModalChecked(true))
  }

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref}>
        {videoDetails?.url && isVppaModalChecked && !isVppaModalOpen && (
          <VideoPlayerProvider>
            <VideoPlayerContainer />
          </VideoPlayerProvider>
        )}
      </div>
    </FocusContext.Provider>
  )
}

export default VideoPlaybackScreen
